import React, { useState, useEffect } from 'react';
import { DropdownIndicator, getTranslatedText } from '@nile/components';
import { DropdownArrow } from '@nile/mangifera/src/Pebbles/select';
import { TextField, Tippy } from '@superops/ui-design-system';
import ClientSiteSelection from '@nile/client_management/src/Pages/Invoice/ClientSiteSelection';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import { injectIntl } from 'react-intl';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';

const ValueEditor = ({
  operator,
  value,
  handleOnChange,
  title,
  className,
  type,
  inputType,
  values,
  async,
  errors,
  intl,
  selectedItem,
  allConditions,
  isDisabled = false,
  parentLabel = false
}) => {
  let initialOptions = async ? [] : values;
  const [options, setOptions] = useState(initialOptions);

  useEffect(() => {
    if (async) {
      values.then((res) => {
        setOptions(res);
      });
    }
  }, [async, values]);

  if (!type || !operator || operator === 'null' || operator === 'notNull') {
    return null;
  }

  let parsedValue = _.cloneDeep(value);
  let displayValue = undefined;
  if (typeof parsedValue === 'object' && parsedValue.length) {
    parsedValue = value.map((el) => {
      return {
        name: el?.name || el,
        label: el?.label || el,
        value: el?.name || el
      };
    });
  }
  const allOptions =
    options &&
    options.map((item) => {
      if (item.label === value) displayValue = item;
      return {
        ...item,
        value: item.name
      };
    });

  const indicatorSeparatorStyle = {
    width: 0
  };

  const IndicatorSeparator = ({ innerProps }) => {
    return <span style={indicatorSeparatorStyle} {...innerProps} />;
  };

  const withTooltip = (component) => {
    if (!isDisabled) return component;
    return (
      <Tippy
        title={`${isDisabled &&
          parentLabel &&
          getTranslatedText(intl, 'common.ticket.field.dependant.title', {
            name: parentLabel
          })}`}
        duration={250}
        delay={100}
        placement="bottom-start"
        arrow={false}
        theme="dark"
        appendTo={document.body}
      >
        <div className="tooltip-wrapper w-100">{component}</div>
      </Tippy>
    );
  };

  if (selectedItem?.isDependant) {
    const client = allConditions?.find((el) => el.name === 'client')?.value;
    const site = allConditions?.find((el) => el.name === 'site')?.value;
    switch (selectedItem.name) {
      case 'client':
        return withTooltip(
          <ClientSiteSelection
            updateProperties={handleOnChange}
            hideIcon={false}
            site={site}
            client={client}
          />
        );
      default:
        break;
    }
  }

  switch (type) {
    case 'select':
    case 'radio':
      return withTooltip(
        <Select
          className={`${className}`}
          classNamePrefix="value_selector"
          //value={value === '' ? '' : options.find(el => el.label == value.label)}
          value={{ name: value, value, label: value }}
          key={displayValue ? JSON.stringify(displayValue) : Math.random()}
          components={{ IndicatorSeparator, DropdownIndicator }}
          title={title}
          onChange={(value) => handleOnChange(value)}
          options={allOptions}
          placeholder={getTranslatedText(intl, 'app.chooseValue.pl')}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          name="valueselector"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
          isDisabled={isDisabled}
        />
      );

    case 'multiselect':
    case 'multi_select':
    case 'checkbox':
      return withTooltip(
        <Select
          className={`${className}`}
          classNamePrefix="value_selector"
          //value={value === '' ? '' : options.find(el => el.label == value.label)}
          value={parsedValue}
          components={{ IndicatorSeparator, DropdownArrow }}
          title={title}
          onChange={(value) => handleOnChange(value)}
          options={allOptions}
          placeholder={getTranslatedText(intl, 'app.chooseValue.pl')}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          isMulti
          name="valueselector"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 })
          }}
          isDisabled={isDisabled}
        />
      );

    case 'date':
      return (
        <DatePicker
          selected={value ? dayjs(value).toDate() : ''}
          placeholderText="Choose date"
          onChange={(date) => {
            handleOnChange(date ? dayjs(date).format('YYYY-MM-DD') : '');
          }}
          dateFormat="yyyy-MM-dd"
          portalId="root-portal"
        />
      );
    case 'datetime':
      return (
        <DatePicker
          selected={value ? dayjs(value).toDate() : ''}
          placeholderText="Choose date"
          onChange={(date) => {
            handleOnChange(
              date ? dayjs(date).format('YYYY-MM-DDTHH:mm:ss') : ''
            );
          }}
          dateFormat="yyyy-MM-dd h:mm aa"
          showTimeInput
          portalId="root-portal"
        />
      );

    default:
      return withTooltip(
        <TextField
          value={value}
          title={title}
          onChange={(val) => {
            handleOnChange(val);
          }}
          placeholder={getTranslatedText(intl, 'admin.sla.enterText.pl')}
          type={inputType || 'text'}
          className={`${className} rule-text-field`}
          error={errors?.[0]}
          isDisabled={isDisabled}
        />
      );
  }
};

ValueEditor.displayName = 'ValueEditor';

ValueEditor.propTypes = {
  field: PropTypes.string,
  operator: PropTypes.string,
  value: PropTypes.any,
  handleOnChange: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  type: PropTypes.oneOf(['select', 'checkbox', 'radio', 'text']),
  inputType: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.object)
};

export default injectIntl(ValueEditor);
